import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import recentPostCss from "./RecentPost.module.css";
// import project1 from "../../asset/Image/project1.jpg";
// import project2 from "../../asset/Image/project2.jpg";
// import project3 from "../../asset/Image/project3.jpg";
import RestClient from "../../RestApi/RestClient";
import AppUrl from "../../RestApi/AppUrl";
import Rotate from "react-reveal/Rotate";
import Fade from "react-reveal/Fade";
import Loader from "../../shared/Loader/Loader";

export default function RecentPost() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeProjects).then((result) => {
      setProjects(result);
      setLoading(false);
    });
  }, []);
  return (
    <>
      {loading && <Loader />}
      <Container className="text-center">
        <Fade top>
          <h1 className="title">Recent Projects</h1>
        </Fade>
        <div className="bottom"></div>
        <Row className="">
          {projects.map((project, i) => {
            return (
              <Col lg={4} md={6} sm={12} key={i}>
                <Rotate top left>
                  <Card className={`${recentPostCss.cardContainer} mb-3`}>
                    <Card.Img variant="top" src={project.img_one} />
                    <Card.Body>
                      <Card.Title className={`${recentPostCss.cardTitle}`}>
                        {project.project_name}
                      </Card.Title>
                      <Card.Text className={`${recentPostCss.cardDes}`}>
                        {project.project_description}
                      </Card.Text>
                      <Link to={`/projectDetails/${project.id}`}>
                        <Button variant="primary">Visit Now</Button>
                      </Link>
                    </Card.Body>
                  </Card>
                </Rotate>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
}
